export default {
    page_title: "Kevi | Reporte de Mensajes",
    title: "Mensajes",
    modal: {
        title: "Notificación",
    },
    stats: {
        total: "Mensajes",
        email: "E-mails",
        sms: "SMS",
        rcs: "RCS",
        whatsapp: "WhatsApp",
        oficial_whatsapp: "WhatsApp Oficial",
        accepted: "Aceptadas",
        sent: "Enviadas",
        failed: "Fallidas",
        scheduled: "Programadas",
        queued: "Procesando",
    },
    table: {
        message: "Mensaje",
        sender: "Disparador",
    },
    content: {
        subject_prefix: "Asunto: ",
    },
    filters: {
        automation: "Automatización",
        sender: {
            label: "Disparador",
        },
        status: {
            label: "Estado",
            options: {
                accepted: "Aceptada",
                scheduled: "Programada",
                sent: "Enviada",
                failed: "Fallida",
                queued: "Procesando",
            },
        },
        method: {
            label: "Método",
            options: {
                email: "E-mail",
                sms: "SMS",
                rcs: "RCS",
                whatsapp: "WhatsApp",
                whatsapp_cloud: "WhatsApp Oficial",
            },
        },
    },
    actions: {
        retry_failed_aria: "Intentar reenviar mensajes fallidos",
        retry_failed_tooltip: "Intentar de nuevo",
        cancel_scheduled_aria: "Cancelar mensajes programados",
        cancel_scheduled_tooltip: "Cancelar programacion",
        view_email_body: "Ver cuerpo del email",
    },
    confirmations: {
        retry_failed: "¿Desea reenviar ahora las {0} fallidas?",
        cancel_scheduled: "¿Realmente desea cancelar los mensajes programados?",
    },
    toasts: {
        retry_success: "Mensajes devueltos a la cola",
        cancel_success: "Mensajes cancelados",
    },
};
